import ShiritoriLogoPath from '../assets/image/shiritori-main.webp';
import { Link } from 'react-router-dom';
import { GetNavigatorShareData as GetDefautShareData, SocialMediaShare } from '../util/share-helper.ts';
import { useTranslation } from 'react-i18next';
import { ReturnToGame } from '../components/home/return-to-game.tsx';

export function BugsFeaturesView() {
    const { t } = useTranslation();

    function translateRich(key: string): React.ReactNode {
        const words = t(`bugsAndFeatures.${key}`).split(' ');

        function innerText(segment: string): string {
            return segment.substring(2, segment.length - 1).replaceAll('_', ' ');
        }

        return (
            <>
                {words.map((word, i) => {
                    if (word.startsWith('k|')) {
                        return (<Keyword key={i} text={innerText(word) + ' '} />);
                    } else if (word.startsWith('b|')) {
                        return (<strong key={i}>{innerText(word)} </strong>);
                    } else if (word.startsWith('i|')) {
                        return (<em key={i}>{innerText(word)} </em>);
                    } else if (word.startsWith('a|')) {
                        const innerText = word.substring(2, word.length - 1);
                        const parts = innerText.split('|');
                        return (<a key={i} href={parts[0]} className="underline" >{parts[1]!.replaceAll('_', ' ')}</a>)
                    }
                    return word + ' ';
                })}
            </>
        );
    }

    function share() {
        const data = GetDefautShareData(window.location.origin);
        SocialMediaShare(data);
    }

    return (
        <>
            <Link to="/" className="h-1/4 w-[30vh] hover:bg-slate-50/10 outline-white/35">
                <img src={ShiritoriLogoPath} alt={t('common.txtLogoAlt')} className="w-full h-full drop-shadow-heavy object-contain" />
            </Link>

            <div className="h-3/4 w-full max-w-prose px-12 z-10 select-text">
                <ReturnToGame />
                <h1 className="text-3xl font-medium my-6 text-center">{t('bugsAndFeatures.title')}</h1>

                <p className="my-4 text-base">{translateRich('p1')}</p>
                <p className="my-4 text-base">
                    {t('bugsAndFeatures.cta.l1')}
                    <a className="underline cursor-pointer" onClick={share}>{t('bugsAndFeatures.cta.a')}</a>
                    {t('bugsAndFeatures.cta.l2')}
                </p>
                <p className="my-4 text-base">{translateRich('p2')}</p>

                <Heading>{t('bugsAndFeatures.bugs.title')}</Heading>
                <p className="my-4 text-base">{translateRich('bugs.p1')}</p>

                <Heading>{t('bugsAndFeatures.features.title')}</Heading>
                <p className="my-4 text-base">{translateRich('features.p1')}</p>
            </div>
            <div className="my-12"></div>
        </>
    );
}

function Keyword({ text }: { text: string }) {
    return (
        <span className="italic font-medium">{text}</span>
    );
}

function Heading({ children }: { children: React.ReactNode }) {
    return (
        <h2 className="my-8 text-2xl">{children}</h2>
    );
}
